import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { popModal } from '@/redux/modals/actions';

/**
 * Pops the topmost modal from the Redux modal stack.
 */
export const useCloseModal = () => {
  const dispatch = useDispatch();
  return useCallback(() => dispatch(popModal()), [dispatch]);
};
